<template>
  <div :class="`Log__main ${logMainClass}`">
    <div class="Log__btn_area ft_en">
      <div class="Log__btn_left">
        <div
          class="Log__btn"
          :class="{ 'Log__btn--active': isCategory == 1 }"
          @click="setChartWeek"
        >
          Week
        </div>
        <div
          class="Log__btn"
          :class="{ 'Log__btn--active': isCategory == 2 }"
          @click="setChartMonth"
        >
          Month
        </div>
        <div
          class="Log__btn"
          :class="{ 'Log__btn--active': isCategory == 3 }"
          @click="setChartYear"
        >
          Year
        </div>
      </div>
      <div class="Log__btn_right">
        <div class="Arrow__btn Arrow__btn_left" @click="previousTime" />
        <div class="Log__date_area">
          <div class="Log__date_line">
            <span class="Log__date_box">
              <span class="Log__date_tx_md">{{ firstShow }}</span>
              <span v-if="isCategory !== 3" class="Log__date_tx_sm">&#040;{{ firstShowDate }}&#041;</span>
            </span>
          </div>
          <span class="Log__date_box">
            <span class="Log__date_tx_md">{{ lastShow }}</span>
            <span v-if="isCategory !== 3" class="Log__date_tx_sm">&#040;{{ lastShowDate }}&#041;</span>
          </span>
        </div>
        <div class="Arrow__btn Arrow__btn_right" @click="nextTime" />
      </div>
    </div>
    <div class="Log_chart_area">
      <p class="Scroll_tx _mg0 _mg-b10">
        タップして横に動かせます
      </p>
      <div v-if="isMobile" class="Log_chart_scroll">
        <line-chart
          class="Log_chart_box"
          chart-class="Log_chart"
          chart-id="myLineChart"
          :width="2"
          :height="1"
          :chart-data="chartData"
          :options="chartOptionsMobile"
        />
      </div>
      <div v-else class="Log_chart_scroll">
        <line-chart
          class="Log_chart_box"
          chart-class="Log_chart"
          chart-id="myLineChart"
          :width="2"
          :height="1"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </div>
      <div class="Log_chart_item_area">
        <div class="Log_chart_item Log_chart_item--cl01">
          心の状態
        </div>
        <div class="Log_chart_item Log_chart_item--cl02">
          体の状態
        </div>
        <div class="Log_chart_item Log_chart_item--cl03">
          マインドフルネス時間
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/views/components/Charts/LineChart'
import LogService from '@/services/logService'
import moment from 'moment'
const releaseTime = '2021/11/20'

export default {
  name: 'LogChart',
  components: { LineChart },
  props: {
    logMainClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMobile: false,
      width: 0,
      height: 0,
      isYear: 0,
      isMonth: 0,
      isWeek: 0,
      firstDay: 0,
      lastDay: 0,
      firstShow: '',
      Month: '',
      firstShowDate: '',
      lastShow: '',
      lastShowDate: '',
      isLabel: 0,
      isCategory: 2,
      listDataAll: [],
      listDataShow: [],
      chartData: {},
      chartOptions: {
        interaction: {
          mode: 'detaset',
          intersect: false
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            offset: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [
            {
              offset: true,
              display: false,
              ticks:
              {
                min: 0,
                stepSize: 1,
                beginAtZero: true
              }
            },
            {
              id: 'B',
              offset: true,
              ticks:
              {
                min: 0,
                stepSize: 0.25,
                maxTicksLimit: 200,
                display: false
              }
            }
          ]
        }
      },
      chartOptionsMobile: {
        interaction: {
          mode: 'detaset',
          intersect: false
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            offset: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [
            {
              offset: true,
              display: false,
              ticks:
              {
                min: 0,
                stepSize: 1,
                beginAtZero: true
              }
            },
            {
              id: 'B',
              offset: true,
              ticks:
              {
                min: 0,
                stepSize: 0.25,
                maxTicksLimit: 200,
                display: false
              }
            }
          ]
        }
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.currentInMonth()
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    async getListDataLog(first, last) {
      const queryParams = {
        params: {
          first: first,
          last: last
        }
      }
      this.$store.dispatch('loading/updateLoading', true)
      const response = await LogService.index(queryParams)
      this.listDataAll = response ? response.data : []
      this.$store.dispatch('loading/updateLoading', false)
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate()
    },
    showDateOfDay(date) {
      return moment(date).format('(ddd)')
    },
    setChartWeek() {
      this.isCategory = 1
      this.currentWeek()
    },
    setChartMonth() {
      this.isCategory = 2
      this.currentInMonth()
    },
    setChartYear() {
      this.isCategory = 3
      this.changeTimeOnYear(this.isYear)
    },
    previousTime() {
      switch (this.isCategory) {
        case 1:
          this.changeTimeOnWeek(1)
          break
        case 3:
          if (this.isYear > moment(releaseTime, 'YYYY/MM/DD').format('Y')) {
            var pYear = this.isYear - 1
            this.changeTimeOnYear(pYear)
          }
          break
        default: {
          const format_release_time = moment(releaseTime, 'YYYY/MM/DD').format('YYYY/MM/01 HH:mm:ss')
          const format_month = moment(this.Month, 'YYYY/MM/DD').format('YYYY/MM/01 HH:mm:ss')
          if (Date.parse(format_month) > Date.parse(format_release_time)) {
            var preMonth = this.isMonth - 1
            var year = this.isYear
            if (preMonth === 0) {
              preMonth = 12
              year = year - 1
            }
            this.changeTimeOnMonth(preMonth, year)
          }
        }
      }
    },
    nextTime() {
      switch (this.isCategory) {
        case 1:
          this.changeTimeOnWeek(3)
          break
        case 3:
          var pYear = this.isYear + 1
          this.changeTimeOnYear(pYear)
          break
        default:
          var nextMth = this.isMonth + 1
          var year = this.isYear
          if (nextMth === 13) {
            nextMth = 1
            year = year + 1
          }
          this.changeTimeOnMonth(nextMth, year)
      }
    },
    currentInMonth() {
      const today = new Date()
      const month = today.getMonth() + 1
      const year = today.getFullYear()
      this.changeTimeOnMonth(month, year)
    },
    async changeTimeOnMonth(month, year) {
      const dayInMonth = this.daysInMonth(month, year)
      const firstMonth = year + '-' + month + '-' + '01'
      const first = new Date(firstMonth.replace(/-/g, '/'))
      const first_format = moment(first).format('YYYY/MM/DD')
      const lastMonth = year + '-' + month + '-' + dayInMonth
      const last = new Date(lastMonth.replace(/-/g, '/'))
      const last_format = moment(last).format('YYYY/MM/DD')
      this.firstShow = month + '.1'
      this.firstShowDate = moment(first).format('ddd')
      this.lastShow = moment(last).format('M.D')
      this.lastShowDate = moment(last).format('ddd')
      this.lastDay = dayInMonth
      this.isMonth = month
      this.isYear = year
      this.Month = first_format
      this.handleLabels(dayInMonth)
      this.$store.dispatch('loading/updateLoading', true)
      await this.getListDataLog(first_format, last_format)
      this.handleDataMonth()
      this.$store.dispatch('loading/updateLoading', false)
    },
    handleDataMonth() {
      var result = []
      this.listDataAll.forEach(item => {
        var key = moment(item.created_at).format('D')
        result[key] = item
      })
      this.handleDataMonthDetail(result)
    },
    handleDataMonthDetail(result) {
      const date = this.lastDay
      const logs = { 'heart': [], 'health': [], 'meditation': [] }
      for (let i = 0; i < date; i++) {
        const day = i + 1
        if (result[day]) {
          logs['heart'][i] = result[day]['heart_beat_rate']
          logs['health'][i] = result[day]['health_state']
          logs['meditation'][i] = ((result[day]['meditation_time'] + result[day]['meditation_melontv']) / 60).toFixed(2)
        } else {
          logs['heart'][i] = null
          logs['health'][i] = null
          logs['meditation'][i] = null
        }
      }
      this.getChartData(logs)
    },
    handleLabels(day) {
      const array = []
      for (let i = 0; i < day; i++) {
        array[i] = i + 1
      }
      this.isLabel = array
    },
    /**
     *
     *
     * Mindful log for week
     *
     *
     **/
    async currentWeek() {
      const today = new Date()
      const currentWeek = []
      for (let i = 0; i < 7; i++) {
        currentWeek[i] = new Date(today.setDate(today.getDate() - today.getDay() + i + 1))
      }
      this.firstShow = moment(currentWeek[0]).format('M.D')
      this.firstShowDate = moment(currentWeek[0]).format('ddd')
      this.lastShow = moment(currentWeek[6]).format('M.D')
      this.lastShowDate = moment(currentWeek[6]).format('ddd')
      this.isWeek = currentWeek
      this.$store.dispatch('loading/updateLoading', true)
      await this.getListDataLog(this.changeTimeFirst(currentWeek[0]), this.changeTimeLast(currentWeek[6]))
      this.handleLabelWeek()
      this.handleLogWeek()
      this.$store.dispatch('loading/updateLoading', false)
    },
    changeTimeFirst(date) {
      const old = Date.parse(date) - 24 * 60 * 60 * 1000
      const first = new Date(old)
      return first
    },
    changeTimeLast(date) {
      const old = Date.parse(date) + 24 * 60 * 60 * 1000
      const last = new Date(old)
      return last
    },
    async changeTimeOnWeek(key) {
      const mondayCur = moment(this.isWeek[0]).format('YYYY-MM-DD')
      const mondaySec = Date.parse(mondayCur)
      let nextDay = 0
      const currentWeek = []
      if (key === 1) {
        for (let i = 0; i < 7; i++) {
          currentWeek[i] = new Date(mondaySec + nextDay - 7 * 24 * 60 * 60 * 1000)
          nextDay += 24 * 60 * 60 * 1000
        }
      } else {
        for (let i = 0; i < 7; i++) {
          currentWeek[i] = new Date(mondaySec + nextDay + 7 * 24 * 60 * 60 * 1000)
          nextDay += 24 * 60 * 60 * 1000
        }
      }
      const mon_of_week = moment(currentWeek[0]).format('YYYY/MM/DD HH:mm:ss')
      const sun_of_week = moment(currentWeek[6]).format('YYYY/MM/DD HH:mm:ss')
      const format_release_time = moment(releaseTime, 'YYYY/MM/DD').format('YYYY/MM/DD HH:mm:ss')
      if (Date.parse(mon_of_week) >= Date.parse(format_release_time) || (Date.parse(mon_of_week) <= Date.parse(format_release_time) && Date.parse(format_release_time) <= Date.parse(sun_of_week))) {
        this.firstShow = moment(currentWeek[0]).format('M.D')
        this.firstShowDate = moment(currentWeek[0]).format('ddd')
        this.lastShow = moment(currentWeek[6]).format('M.D')
        this.lastShowDate = moment(currentWeek[6]).format('ddd')
        this.isWeek = currentWeek
        await this.getListDataLog(this.changeTimeFirst(currentWeek[0]), this.changeTimeLast(currentWeek[6]))
        this.handleLabelWeek()
        this.handleLogWeek()
      }
    },
    handleDateToDay(date) {
      return moment(date).format('D')
    },
    handleLabelWeek() {
      const label = []
      let key = 0
      this.isWeek.forEach(item => {
        label[key] = moment(item).format('D')
        key++
      })
      this.isLabel = label
    },
    handleLogWeek() {
      const result = []
      this.listDataAll.forEach(item => {
        const key = moment(item.created_at).format('D')
        result[key] = item
      })
      this.handleDataWeekDetail(result, this.isLabel)
    },
    handleDataWeekDetail(result, date) {
      const logs = { 'heart': [], 'health': [], 'meditation': [] }
      for (var i = 0; i < 7; i++) {
        const day = date[i]
        if (result[day]) {
          logs['heart'][i] = result[day]['heart_beat_rate']
          logs['health'][i] = result[day]['health_state']
          logs['meditation'][i] = ((result[day]['meditation_time'] + result[day]['meditation_melontv']) / 60).toFixed(2)
        } else {
          logs['heart'][i] = null
          logs['health'][i] = null
          logs['meditation'][i] = null
        }
      }
      this.getChartData(logs)
    },
    /**
     * Handle date of Year
     *
     *
     *
     */
    async changeTimeOnYear(year) {
      this.firstShow = year + '/1'
      this.lastShow = year + '/12'
      this.isYear = year
      const first = new Date(year + '/1/1')
      const last = new Date(year + '/12/31')
      await this.getListDataLog(first, last)
      this.handleLabels(12)
      this.handleDataYear()
    },
    handleDataYear() {
      const result = []
      this.listDataAll.forEach(item => {
        const key = moment(item.created_at).format('M')
        if (!result[key]) {
          result[key] = []
        }
        result[key].push(item)
      })
      this.handleDataYearDetail(result)
    },
    handleDataYearDetail(result) {
      const logs = { 'heart': [], 'health': [], 'meditation': [] }
      for (var i = 0; i < 12; i++) {
        const data = i + 1
        if (result[data]) {
          const length = result[data].length
          let heart = 0
          let health = 0
          let meditation = 0
          for (let j = 0; j < length; j++) {
            heart = heart + result[data][j]['heart_beat_rate']
            health = health + result[data][j]['health_state']
            meditation = meditation + result[data][j]['meditation_time'] + result[data][j]['meditation_melontv']
          }
          logs['heart'][i] = (heart / length).toFixed(1)
          logs['health'][i] = (health / length).toFixed(1)
          logs['meditation'][i] = (meditation / (length * 60)).toFixed(2)
        } else {
          logs['heart'][i] = null
          logs['health'][i] = null
          logs['meditation'][i] = null
        }
      }
      this.getChartData(logs)
    },
    /**
     * Chart data
     *
     */
    getChartData(logs) {
      this.chartData = {
        yAxes: [ // Ｙ軸設定
          {
            scaleLabel: { // 軸ラベル
              display: false, // 表示の有無
              labelString: '縦軸ラベル', // ラベル
              fontFamily: 'sans-serif',
              fontColor: 'blue', // 文字の色
              fontSize: 16 // フォントサイズ
            },
            gridLines: { // 補助線
              color: 'rgba(0, 0, 255, 0.2)', // 補助線の色
              zeroLineColor: 'black' // y=0（Ｘ軸の色）
            },
            ticks: { // 目盛り
              min: 1, // 最小値
              fontColor: 'blue', // 目盛りの色
              fontSize: 14 // フォントサイズ
            }
          }
        ],
        // [ X軸のラベルです。期間設定によってここも動的に変わることになると思います。 ]
        labels: this.isLabel,
        datasets: [
          {
            label: '心の状態',
            // [ 心の状態のデータです。データがない日は「null」を入れてください。 ]
            data: logs['heart'],
            borderColor: '#EA609E',
            backgroundColor: '#EA609E',
            lineTension: 0,
            fill: false,
            spanGaps: true
          },
          {
            label: '体の状態',
            // [ 体の状態のデータです。データがない日は「null」を入れてください。 ]
            data: logs['health'],
            borderColor: '#F08441',
            backgroundColor: '#F08441',
            lineTension: 0,
            fill: false,
            spanGaps: true
          },
          {
            label: 'マインドフルネス時間',
            // [ マインドフルネス時間のデータです。データがない日は「null」を入れてください。 ]
            data: logs['meditation'],
            borderColor: '#1E87C8',
            backgroundColor: '#1E87C8',
            lineTension: 0,
            fill: false,
            spanGaps: true,
            yAxisID: 'B'
          }
        ]
      }
    }
  }
}
</script>
